import API from "../../../app/api";

export const getvideoGallery = async () => {
  try {
    const res = await API.get("/banners/video-gallery");
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch Home Page");
    }
    return res.data.data || [];
  } catch (error) {
    console.error("getvideoGallery error:", error);
    return [];
  }
};